/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menureadlunchheading3Inputs */

const en_menureadlunchheading3 = /** @type {(inputs: Menureadlunchheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read a lunch menu`)
};

const de_menureadlunchheading3 = /** @type {(inputs: Menureadlunchheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittagsmenü einlesen`)
};

/**
* | output |
* | --- |
* | "Read a lunch menu" |
*
* @param {Menureadlunchheading3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menureadlunchheading3 = /** @type {((inputs?: Menureadlunchheading3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menureadlunchheading3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menureadlunchheading3(inputs)
	return de_menureadlunchheading3(inputs)
});
export { menureadlunchheading3 as "menuReadLunchHeading" }